import React from 'react';
import './styles/global.scss';
import BaseLayout from './components/BaseLayout';

export default function App() {
    return <BaseLayout />;
}
